import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={393}
    height={217}
    fill="none"
    {...props}
  >
    <path
      stroke="#00E9BA"
      strokeDasharray="8 8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M210.5 61H406M178 61H-17.5"
    />
    <path
      fill="#425596"
      stroke="#425596"
      d="m191.365 63.906-.08-.197-.197-.08-7.752-3.129 7.752-3.129.197-.08.08-.197 3.131-7.76 3.139 7.76.08.197.197.08 7.752 3.129-7.752 3.129-.197.08-.08.196-3.139 7.76-3.131-7.76Z"
    />
    <path fill="#24EAA8" d="M58 34 39 0 20 34h38Z" />
    <path
      stroke="#425596"
      strokeDasharray="8 8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M39 216V20.5"
    />
    <path fill="#fff" d="M38.5 27a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11Z" />
  </svg>
)
export default SvgComponent
